<template>
  <div class="sea_result">
    <!-- 搜索查询 -->
    <div class="content">
      <div class="infoCon">
        <!-- 面包屑导航 -->
        <div class="mbnav inner">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">
              <img class="homeIcon" src="/statics/image/index/home.png" alt />
              首页
            </el-breadcrumb-item>
            <el-breadcrumb-item>搜索查询</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="searCon">
          <!-- 分类 -->
          <div class="top">
            <div class="inner">
              <span
                v-for="(item,index) in searchList"
                :key="index"
                :class="fenid == item.cate_id?'act':''"
                @click="changeFen(item.cate_id)"
              >{{item.cate_name}}({{item.article_num}})</span>
            </div>
          </div>
          <div class="inner">
            <div class="searList">
              <div
                class="searItem"
                v-for="(item,index) in article.articlelist"
                :key="index"
                @click="toNewsInfo(fenid,item.article_id)"
              >
                <div class="name">
                  <span class="title">{{item.article_title}}</span>
                  <span class="time">{{item.publish_at}}</span>
                </div>
                <p>{{item.article_describe}}</p>
              </div>
            </div>
            <!-- 分页 -->
            <div class="fenye clearfix">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pages.size"
                layout="prev, pager, next, jumper"
                :total="newsTotal"
                prev-text="上一页"
                next-text="下一页"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fenid: null,
      currentPage: 1, //当前页数
      pages: {
        page: 1,
        size: 10
      },
      newsTotal: 0, //总条数
      topvalue: "",
      searchList: [],
      article: {}
    };
  },
  created() {
    this.topvalue = localStorage.getItem("topvalue");
    this.getSearch();
    this.pages.page =1;
    this.currentPage = 1;
  },
  methods: {
    toNewsInfo(cate_id,id) {
      this.$router.push({
        path: "/xqNews_detail",
        query: {
          cate_id:cate_id,
          id: id
        }
      });
    },
    // 页数改变时触发
    handleCurrentChange(val) {
      // console.log(val);
      this.pages.page = val;
      this.getArticlelist();
      $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
    },
    // 搜索接口
    getSearch() {
      var that = this;
      var ps = {
        keyword: that.topvalue
      };
      that.$api.index.search(ps).then(function(res) {
        if (res.code == 200) {
          that.searchList = res.result;
          that.fenid = res.result[0].cate_id;
          that.getArticlelist();
        }
      });
    },
    // 文章列表
    getArticlelist() {
      var that = this;
      var ps = {
        cate_id: that.fenid * 1,
        page: that.pages.page,
        size: that.pages.size,
        keyword: that.topvalue
      };
      that.$api.index.articlelist(ps).then(function(res) {
        if (res.code == 200) {
          that.article = res.result;
          that.newsTotal = res.result.total * 1;
        }
      });
    },
    // 切换分类
    changeFen(id) {
      this.fenid = id;
      this.pages.page = 1;
      this.currentPage = 1;
      this.getArticlelist();
    }
  },
  watch: {
    $route(to, from) {
      // console.log(to.name);
      if (to.name != "sea_result") {
        localStorage.removeItem("topvalue");
        this.topvalue="";
      }
    }
  }
};
</script>

<style>
</style>